import styled, {css} from 'styled-components'

export default {
	Wrapper: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-bottom: 60px;
	`,

	ContentDiv: styled.div`
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 32px;
		padding: 24px;
		height: fit-content;
	`,
	// "HeaderCover": styled.div`
	//     position: absolute;
	//     width: 100%;
	//     height: 100%;
	//     background: linear-gradient(transparent 40%, white 100%);
	// `,

	HeaderDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 20px;

		& > h2 {
			${({theme}) => theme.font['medium-regular']};
			line-height: 22px;
		}
	`,
	ContentElement: styled.div`
		display: flex;
		flex-direction: column;
		gap: 4px;

		& > h2 {
			${({theme}) => theme.font['small-regular']};
			color: ${({theme}) => theme.color['grey4']};
		}

		& > p {
			${({theme}) => theme.font['small-regular']};
			color: ${({theme}) => theme.color['grey4']};
		}
	`,
	TitleDiv: styled.div`
		display: flex;
		align-items: center;
		gap: 8px;

		& > h2 {
			${({theme}) => theme.font['xxlarge-bold']};
		}

		& > p {
			height: fit-content;
			${({theme}) => theme.font['tiny-semibold']};
			color: ${({theme}) => theme.color['white']};
			padding: 4px 8px;
			border-radius: 9999px;
			white-space: nowrap;

			background-color: ${({theme, $type}) => {
				if ($type === 1) return theme.color['red']
				else if ($type === 2) return theme.color['orange']
				else if ($type === 3) return theme.color['blue']
				else if ($type === 4) return theme.color['green']
				else if ($type === 5) return theme.color['grey4']
			}};
		}
	`,

	Area: styled.div`
		display: flex;
		flex-direction: column;
		gap: 12px;
	`,
	AreaTitleDiv: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: end;
		padding-bottom: 12px;
		border-bottom: 1px solid ${({theme}) => theme.color['black']};

		& > h2 {
			width: 100%;
			${({theme}) => theme.font['xlarge-bold']};
		}

		& > button {
			display: flex;
			justify-content: end;
			align-items: center;
			gap: 4px;
			${({theme}) => theme.font['small-regular']};

			& > img {
				height: 10px;
			}
		}
	`,
	AreaBody: styled.div`
		display: none;
		flex-direction: column;
		gap: 12px;

		${({$isPrize}) =>
			$isPrize
				? css`
						max-height: 500px;
						overflow-y: scroll;
				  `
				: ' height: fit-content;'}

		${({$active}) =>
			$active &&
			css`
				display: flex;
			`}
	`,

	SeriesBtn: styled.button`
		display: flex;
		gap: 24px;
		align-items: center;

		& > h2 {
			width: 100%;
			${({theme}) => theme.font['large-medium']};
			text-align: left;
			word-break: break-word;
		}

		& > img {
			height: 10px;
		}
	`,
	InfoElement: styled.div`
		display: flex;
		align-items: center;
		gap: 16px;

		& > h2 {
			width: fit-content;
			${({theme}) => theme.font['large-medium']};
			color: ${({theme}) => theme.color['grey4']};
			white-space: nowrap;
		}

		& > p {
			flex-grow: 1;
			${({theme}) => theme.font['large-medium']};
			text-align: right;
		}
	`,
	PrizeElement: styled.div`
		display: flex;
		align-items: center;
		gap: 16px;

		& > h2 {
			width: fit-content;
			${({theme}) => theme.font['large-medium']};
			white-space: nowrap;
		}

		& > p {
			flex-grow: 1;
			${({theme}) => theme.font['large-medium']};
			text-align: right;
		}
	`,
	DurationTitleDiv: styled.div`
		display: flex;

		& > p {
			width: 20%;
			${({theme}) => theme.font['small-medium']};
			color: ${({theme}) => theme.color['grey4']};
			text-align: center;
		}
	`,
	DurationElement: styled.div`
		display: flex;

		& > p {
			width: 20%;
			${({theme}) => theme.font['small-medium']};
			text-align: center;
		}

		${({$break}) =>
			$break &&
			css`
				background-color: ${({theme}) => theme.color['grey2']};
				padding: 8px 0;
			`}
	`,

	DetailBtnDiv: styled.div`
		padding: 0 24px;
		margin-top: 40px;

		& + & {
			margin-top: 16px;
		}
	`,

	Option: styled.p`
		width: 100%;
		text-align: end;
		${({theme}) => theme.font['small-regular']};
		margin-top: 8px;
	`,
}
